
import { BROKER_ADD_CONF } from "./brokerDelegate";
import { sendRequest, API_ROOT } from "../../supplementary_components/requests";
import { addPopup, addNotification } from "../../supplementary_components/store";
import { ConfirmationDialogue } from "../../general_components/forms/ConfirmationDialogue";
import { Form } from "../../general_components/forms/Form";
import cloneDeep from "lodash/cloneDeep";
import { MdHistory } from "react-icons/md";
import { openActivitiesPopup } from "../../general_components/activitiesPopup/activitiesPopup";
import activitiesStyles from "../../general_components/activitiesPopup/activitiesPopup.module.scss";

const BROKER_ACTIVITIES_POPUP_KIND = "brokerActivities";
// import { EMPLOYEE_PAGE_OBJECT } from "./employeePageConf";

// Function to format phone and extension
// const combinePhoneWithExtension = (data) => {
//   let result = (data["directLine"] || "-") + ' / ' + (data["extension"] || "-");
//   return result;
// };

// Function to format first and last names
// const combineFullName = (data) => {
//   let result = data["firstName"] + ' ' + data["lastName"];
//   return result;
// };

export const BROKER_LISTING_CONF = {
    getRequestLink: API_ROOT+"brokers",
    columnProportions: "1.5fr 0.6fr 1.6fr 0.8fr 1.3fr 0.6fr 0.4fr 0.6fr 4rem",
    dataTitle: "Broker",
    dataTitlePlural:"Brokers",
    addButton:true,
    addConf: BROKER_ADD_CONF,
    // pageConf: new EMPLOYEE_PAGE_OBJECT(),
    category: 'brokers',
    editAccessLevel: { key: 'BROKERS', level: 'MANAGE' },
    columns :[
        {
            label: "Brokerage Name",
            columnName: "brokerageName",
        },
        {
            label: "MC Number",
            columnName: "mcNumber",
        },
        {
            label: "Address",
            valueGenerator : (data) =>{
                return `${data["addressLine1"] ? data["addressLine1"] + ", " : ""}${data["addressLine2"] ? data["addressLine2"] + ", " : ""}${data["city"]}, ${data["state"]} ${data["postalCode"]}`;
            }
        },
        {
            label: "Main Number",
            columnName: "mainNumber",
            valueInterpreter: (value)=>{
                return value ? value : "-";
            }
        },
        {
            label: "Main Email",
            columnName: "mainEmail",
            valueInterpreter: (value)=>{
                return value ? value : "-";
            }
        },
        {
            label: "Invoices Factored",
            columnName: "factorInvoices",
            valueInterpreter: (value)=>{
                return value ? "Factored" : "Not Factored";
            },
            conditionalFormatting: (value)=>{
                return `& > * {font-weight:${value ? ""  : "bold;"}; }`

            },
        },
        {
            label: "Status",
            columnName: "approved",
            valueInterpreter: (value)=>{
                return value ? "Approved" : "Not Approved";
            },
            conditionalFormatting: (value)=>{
                return `& > * {color:${value ? "var(--successGreen)"  : "var(--lightAlert)"}; font-weight:bold;}`
            },
        },
        {
            label: "Latest Actions",
            columnName: "latestActions",
            alignment: "center",
            customComponent: (broker) => (
                <div
                    className={activitiesStyles.latestActionsContainer}
                    onClick={(e) => {
                        e.stopPropagation();
                        openActivitiesPopup({
                            targetType: "BROKER",
                            objectId: broker.id,
                            titleLabel: broker.brokerageName ?? "",
                            popupKind: BROKER_ACTIVITIES_POPUP_KIND,
                        });
                    }}
                >
                    <MdHistory />
                </div>
            ),
        },
        {
            actionButtons:true,
            notEditableIfValueIs : (val)=>{
                return false;
            },
            onEditAction: (broker, postSuccessAction)=>{
                const addFormClone = cloneDeep(BROKER_ADD_CONF);
                addFormClone.addLink = API_ROOT+'brokers/edit'
                addFormClone.formTitle = "Edit Broker"
                addFormClone.customSubmitButton = "Save Broker"
                addFormClone.columns[0].defaultValue = ()=>{
                    return broker.brokerageName;
                }
                addFormClone.columns[1].defaultValue = ()=>{
                    return broker.mcNumber;
                }
                addFormClone.columns[2].defaultValue = ()=>{
                    return broker.addressLine1;
                }
                addFormClone.columns[3].defaultValue = ()=>{
                    return broker.addressLine2;
                }
                addFormClone.columns[4].defaultValue = ()=>{
                    return broker.city;
                }
                addFormClone.columns[5].defaultValue = ()=>{
                    return broker.state;
                }
                addFormClone.columns[6].defaultValue = ()=>{
                    return broker.postalCode;
                }
                addFormClone.columns[7].defaultValue = ()=>{
                    return broker.mainNumber;
                }
                addFormClone.columns[8].defaultValue = ()=>{
                    return broker.mainEmail;
                }
                addFormClone.columns[9].defaultValue = ()=>{
                    return broker.factorInvoices ? "Factored" : "Not Factored";
                }
                addFormClone.columns[10].defaultValue = ()=>{
                    return broker.usesVector ? "Yes" : "No";
                }
                // Saved for the current company only.
                addFormClone.columns.push({
                    label: "Dispatch Info Header",
                    name: "customHeader",
                    type: "textArea",
                    rowCount: 4,
                    autoComplete: "off",
                    defaultValue: ()=>{
                        return broker.customHeader || "";
                    }
                });
                addFormClone.columns.unshift({
                    hiddenField:true,
                    name:"id",
                    defaultValue:()=>{
                        return broker.id;
                    },
                    processBeforeSending: val => {
                        return parseInt(val);
                    }
                });
                addFormClone.columns.unshift({
                    label: "Status",
                    columnName: "notApprovedForCompanies",
                    name: "notApprovedForCompanies",
                    type: "select",
                    dataset: ["Approved", "Not Approved"],
                    processBeforeSending : val => {
                        let currentNotApprovedCompanies = broker.notApprovedForCompanies;
                        const currentCompanyId = parseInt(localStorage.getItem("currentCompanyId"));
                        const approved = val === "Approved";
                        if(currentNotApprovedCompanies && currentNotApprovedCompanies.length > 0){
                            if(approved){
                                currentNotApprovedCompanies = currentNotApprovedCompanies.filter(num => num !== currentCompanyId);
                                if(currentNotApprovedCompanies.length === 0){
                                    currentNotApprovedCompanies = null;
                                }
                            }else{
                                currentNotApprovedCompanies.push(currentCompanyId);
                            }
                        }else{
                            if(!approved){
                                currentNotApprovedCompanies = [currentCompanyId]
                            }
                        }
                        return  currentNotApprovedCompanies;
                    },
                    defaultValue:()=>{
                        return broker.approved ? "Approved" : "Not Approved";
                    }
                });
                
                
                addPopup(
                    {
                        content:Form, 
                        popupData:{configuration: addFormClone}, 
                        postSuccessAction: ()=>{postSuccessAction()}, 
                        EZCloseAllowed:false
                    }
                )
            },
            onRemoveAction: (broker, postSuccessAction)=>{
                addPopup({
                    content:ConfirmationDialogue, 
                    popupData: {
                        confirmationDialogue:true,
                        action:(postResultAction)=>{
                            sendRequest("DELETE", API_ROOT+`brokers/${broker.id}`, null, ()=>{
                                postSuccessAction();
                                postResultAction(true);
                                addNotification({message: `Broker Was Removed`, type:'success'});
                            }, (e)=>{
                                addNotification({message: e.customError ? e.customError :`Something Went Wrong`, type:'alert'});
                                postResultAction(true);
                            } )
                        },
                        cancelAction:(closePopup)=>{
                            closePopup()
                        },
                        name:"Confirm",
                        formTitle:"Delete Broker",
                        submitTitle:"Delete",
                        message:`Are you sure you want to delete broker "${broker.brokerageName}"?`
                    }, 
                    postSuccessAction: ()=>{
                        
                    }, 
                    EZCloseAllowed:true
                })
                
               
            }
        }
        

    ]
}